import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Sparkles, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const PremiumGate = ({ title }) => {
  const navigate = useNavigate();

  return (
    <div className="relative min-h-[60vh] flex items-center justify-center" data-testid="premium-gate">
      {/* Blurred fake content behind */}
      <div className="absolute inset-0 overflow-hidden select-none pointer-events-none opacity-20 blur-sm">
        <div className="p-8 space-y-6">
          <div className="h-8 w-64 bg-muted rounded" />
          <div className="grid grid-cols-3 gap-4">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="h-24 bg-muted rounded-lg" />
            ))}
          </div>
          <div className="h-64 bg-muted rounded-lg" />
          <div className="grid grid-cols-2 gap-4">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="h-16 bg-muted rounded-lg" />
            ))}
          </div>
        </div>
      </div>

      {/* Paywall overlay */}
      <div className="relative z-10 text-center max-w-md px-6">
        <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-amber-500/20 to-orange-500/20 border border-amber-500/30 flex items-center justify-center mx-auto mb-5">
          <Lock className="w-7 h-7 text-amber-400" />
        </div>
        <h2 className="text-xl font-bold mb-2">{title || 'Contenido Premium'}</h2>
        <p className="text-muted-foreground mb-6 text-sm leading-relaxed">
          Esta seccion esta disponible con un plan de pago. Suscribete para desbloquear todos los analisis financieros, exportaciones y herramientas de IA.
        </p>
        <Button
          onClick={() => navigate('/pricing')}
          className="bg-gradient-to-r from-amber-500 to-orange-600 hover:from-amber-600 hover:to-orange-700 text-white gap-2 px-6"
          data-testid="premium-gate-cta"
        >
          <Sparkles className="w-4 h-4" />
          Ver planes desde $14/mes
          <ArrowRight className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
};

export default PremiumGate;
